import { Cell, Row, flexRender } from "@tanstack/react-table";
import React from "react";
import { FC } from "react";
import { NilonLevelTableDataItem } from "types/NilonLevelTableTypes";
import { handleKeyDownEvent } from "utils/utilsLogic";

interface TableRowProps {
    row: Row<NilonLevelTableDataItem>
}

const rowStyleByLevel = (cell: Cell<NilonLevelTableDataItem, unknown>, index: number) => {
    const level = cell.row.original.level;
    const paddingRowByLevel = `${(index === 0 ? (level * .8) : 0) + 0.5}rem`
    const boldRowByLevel = `${(8 - level)}00`;

    return {
        paddingRight: paddingRowByLevel,
        fontWeight: boldRowByLevel
    }
}

const TableRow: FC<TableRowProps> = ({ row }) => {
    return (
        <tr role="button" tabIndex={0} onKeyDown={(e) => handleKeyDownEvent(e, () => row.toggleExpanded())} onClick={() => row.toggleExpanded()}>
            {row.getAllCells().map((cell, index) => (
                <td key={cell.id} style={rowStyleByLevel(cell, index)}>
                    <div>
                        {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                        )}
                    </div>
                </td>
            ))}
        </tr>
    );
}

export default TableRow;